<template>
  <section class="container">
    <div class="main">
      <div class="header">
        <h2>New Team</h2>
        <div class="btn">
          <v-button
            gray
            @click="handleCancel">Cancel</v-button>
          <v-button
            green
            @click="handleConfirm">Confirm</v-button>
        </div>
      </div>
      <el-form
        ref="form"
        :model="formData"
        :rules="rules">
        <div
          class="box">

          <div class="form form1">
            <div class="item">
              <span class="item-title">Team</span>
              <el-form-item
                ref="team_nm"
                :rules="rules.input"
                prop="team_nm">
                <v-input
                  v-model="formData.team_nm"
                ></v-input>
              </el-form-item>
            </div>
            <div class="item">
              <span class="item-title">Member</span>
              <el-form-item
                ref="member"
                :rules="rules.input"
                prop="member">
                <v-input
                  v-model="formData.member"
                ></v-input>
              </el-form-item>
            </div>

            <div class="item">
              <span class="item-title">Video less than 100MB (mp4, mov)</span>
              <el-form-item
                ref="file_id"
                :rules="rules.upload"
                prop="file_id">
                <span v-if="fileName">
                  <span class="fw-600 color-gray block">{{fileName}}</span>
                  <p class="color-gray2 mg-b-5 mg-t-5">{{file_size}}</p>
                </span>
                <v-upload
                  gray
                  not-upload
                  accept="video/*"
                  :label="fileName?'Edit':'Upload'"
                  :otherData="{
                    target: 'video_file',
                    idKey: 'file_id',
                    nameKey: 'file_pic_path'
                  }"
                  @uploadForm="handlerUploadForm"
                />
              </el-form-item>
            </div>
            <div class="item">
              <span class="item-title">Video Thumbnail (Optional)</span>
              <el-form-item
                ref="preview_file_id"
                prop="preview_file_id">
                <span v-if="formData.preview_file_id">
                  <span class="fw-600 color-gray mg-b-5 block">{{formData.preview_file.client_name}}</span>
                </span>
                <v-upload
                  gray
                  :label="formData.preview_file_id?'Edit':'Upload'"
                  :accept="'image/*'"
                  is-upload-type
                  :otherData="{
                    target: 'preview_file',
                    idKey: 'preview_file_id',
                    nameKey: 'preview_url',
                    type:'pop_traveller_preview'
                  }"
                  @uploadSuccess="handlerUploadSuccess"
                />
              </el-form-item>
            </div>
            <div class="item">
              <span class="item-title">Publish on HoldCover</span>
              <el-form-item
                ref="status"
                :rules="rules.select"
                prop="status">
                <v-radio-group
                  v-model="formData.status"
                  :list="publishList"
                  block
                ></v-radio-group>
              </el-form-item>
            </div>
          </div>

        </div>
      </el-form>
      <div
        class="footer">
        <v-button
          gray
          @click="handleCancel">Cancel</v-button>
        <v-button
          green
          @click="handleConfirm">Confirm</v-button>
      </div>
    </div>
    <aside   v-if="isEdit">
      <div class="box-remark">
        <span class="title">Remarks</span>
        <div class="remarks-container">
          <div
            v-for="(item, index) in remarkLogsData"
            :key="index"
            class="remark-box">
            <div class="remark-header">
              <span>{{ item.cs_name }}</span>
              <span>{{ item.created_at }}</span>
            </div>
            <p>{{ item.message }}</p>
          </div>
        </div>
        <div class="remark-add">
          <v-input
            v-model="message"
            class="mg-b-15"
            append="Add"
            @handlerAppend="handlerRemark"/>
        </div>
      </div>
    </aside>
  </section>
</template>

<script>
import MixinOptions from '@/mixins/options'
import MixinRules from '@/mixins/rules'
import {postToAmazonS3,addPopTravellerRemark,createTravellerTeam,presignedTraveller,presignedDoneTraveller} from '@/api/pop-traveller-team'
import axios from 'axios'
import {Loading} from 'element-ui'
export default {
  name: 'teamForm',
  components:{
  },
  mixins: [MixinOptions,MixinRules],
  props:{
    from:{
      type:Object,
      default:()=>({})
    },
    remark:{
      type:Array,
      default:()=>([])
    },
    id:{
      type:[Number,String],
      default:''
    },
    isEdit:{
      type:Boolean,
      default:false
    }
  },
  data () {
    return {
      loadinginstace:null,
      formData:{
        video_file:'',
        team_nm:'',
        member:'',
        team_id:{},
        status:'',
        file_id:'',
        file_pic_path:'',
        preview_file:'',
        preview_file_id:'',
        preview_url:''
      },
      message:'',
      remarkList: [],
      extraRules: {
        need_ind: [
          {required: true, message: this.$t('placeholder.select'), trigger: ['change', 'blur']},
        ],
      }
    }
  },
  computed:{
    localAllOptions() {
      return this.allOptions23
    },
    remarkLogsData(){
      return this.remarkList||[]
    },
    video_file(){
      let {video_file} = this.formData||{}
      return video_file||{}
    },
    fileName(){
      let {client_name=''} = this.video_file
      let extName = client_name.split('.').pop()
      return extName.toString().toUpperCase()
    },
    file_size(){
      let {file_size} = this.video_file
      if(file_size === 0) return '0 Bytes'
      const k = 1000
      const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
      const i = Math.floor(Math.log(file_size) / Math.log(k))
      return parseFloat((file_size / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i]
    }
  },
  watch:{
    from:{
      immediate:true,
      handler(val){
        if(val&&this.isEdit)
        {
          Object.keys(this.formData).some((key) => {
            if (key in val) {
              this.formData[key] = val[key]
            }
          })
          let {video_file={}} = val||{}
          let {id,url,thumb_url} = video_file||{}
          this.formData.file_id = id
        }
      }
    }
  },
  mounted(){
    this.remarkList = this.remark
  },
  methods: {
    handlerUploadSuccess({ data, result,otherData }) {
      this.$set(this.formData, 'preview_file', data)
      this.$set(this.formData, 'preview_file_id', data.id)
      this.$set(this.formData, 'preview_url', data.path)
      this.$refs['form'].clearValidate(['preview_file_id'])
    },
    handlerUploadForm({ file, params,result, otherData }) {
      this.network().presignedTraveller(params,file)
    },
    handleCancel(){
      if(!this.isEdit){
        this.$router.back()
      }
      this.$emit('cancel')
    },
    handlerRemark() {
      if (this.message) {
        this.network().addAccountRemark()
      }
    },
    handleConfirm(){
      this.$refs.form.validate( (valid) => {
        if (valid) {
          // 額外參數
          this.network().createTravellerTeam()
        }

      })
    },
    network() {
      return {
        createTravellerTeam: async (params) => {
          params = {
            ...this.formData
          }
          if(this.isEdit){
            let {id} = this.$route.params
            params.team_id = id
          }
          const { data } = await createTravellerTeam({
            ...params
          })
          this.$message({
            type: 'success',
            message: 'Success'
          })
          if(!this.isEdit){
            this.$router.push('/records/campaigns/tourist-list')
          }
          this.$emit('success')
        },
        presignedTraveller: async (params,file) => {
          const { data } = await presignedTraveller()

          await this.network().postToAmazonS3(data,file)
        },
        presignedDoneTraveller: async (params,file) => {
          const { data } = await presignedDoneTraveller(params)
          let {file_size} = data
          this.formData.video_file = {
            ...this.formData.video_file,
            file_size
          }
        },
        postToAmazonS3: async (params,file) => {
          try {
            // 构建请求数据
            this.loadinginstace = Loading.service({ fullscreen: true })
            const formData = new FormData()
            formData.append('key', params['key'])
            formData.append('X-Amz-Credential', params['X-Amz-Credential'])
            formData.append('X-Amz-Algorithm', params['X-Amz-Algorithm'])
            formData.append('X-Amz-Date', params['X-Amz-Date'])
            formData.append('Policy', params['Policy'])
            formData.append('X-Amz-Signature', params['X-Amz-Signature'])
            formData.append('file', file)
            // const {data} = await  postToAmazonS3(params)
            // 发送 POST 请求
            const {data} = await axios.post(params.action, formData, {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            })
            // 处理响应
            this.formData.video_file = {file,client_name:file.name}
            this.formData.file_id = params.key
            this.loadinginstace.close()
            await  this.network().presignedDoneTraveller({file_id:params.key,filename:file.name})
          } catch (error) {
            console.error(error)
          }
        },
        addAccountRemark: async () => {
          const {data} = await addPopTravellerRemark({
            team_id: this.id,
            message: this.message
          })
          this.message = ''
          this.remarkList.unshift(data)
        }
      }
    },
  },
}
</script>
<style lang='scss' scoped>
.container{
  display: flex;
  padding: 0 70px;
  margin-top: 20px;
  min-height: calc(100vh - 150px);
  .main{
    margin-right: 30px;
    flex: 1;
    .header{
      display: flex;
      justify-content: space-between;
      margin-bottom: 20px;
      h2{
        padding: 0;
        font-weight: 600;
        font-size: 20px;
        color: #24292E;
      }
    }
    .box{
      padding-bottom: 30px;
      border-bottom: 1px solid #D1D5DA;
      margin-bottom: 30px;
      .form{
        .item{
          .item-title{
            font-weight: 600;
            font-size: 14px;
            color: #24292E;
            margin-bottom: 8px;
            display: inline-block;
          }
          & + .item{
            margin-top: 20px;
          }
        }
      }
      .form1, .formData{
        width: 330px;
      }
      .tips{
        padding-left: 24px;
        margin-top: 4px;
        font-weight: 400;
        font-size: 14px;
        color: #24292E;
      }
    }
    .footer{
      display: flex;
      justify-content: space-between;
      padding-bottom: 30px;
    }
  }
  aside{
    width: 280px;
    .box-remark{
      .title{
        font-weight: 600;
        font-size: 14px;
        color: #24292E;
      }
      .remarks-container {
        z-index: 1;
        max-height: 300px;
        overflow-y: auto;

        .remark-box {
          margin-bottom: 10px;
          font-size: 12px;
          color: #91939a;

          .remark-header {
            display: flex;
            justify-content: space-between;

            span:first-child {
              font-weight: bold;
            }
          }

          p {
            padding-bottom: 10px;
            color: #616266;
          }
        }
      }
      .remark-add {
        z-index: 2;
        margin: 0 -15px;
        padding: 15px 15px 0 15px;
      }
    }
  }
  /deep/.birth{
    .year{
      width: 140px;
      margin-right: 0;
    }
  }
  /deep/.el-radio-group{
    display: flex;
    flex-direction: column;
  }
  /deep/.el-radio{
    font-weight: 600;
    font-size: 14px;
    color: #24292E;
    & + .el-radio{
      margin-top: 4px;
    }
  }
}
</style>
